import { useCart } from '../../../hooks/useCart';

export default function CartDrawer() {
  const { items, isOpen, closeCart, removeItem, updateQuantity, totalPrice } = useCart();

  const handleCheckout = () => {
    if (items.length === 0) return;
    const lineItems = items
      .map((i) => `${encodeURIComponent(i.variantId.split('/').pop() || '')}:${i.quantity}`)
      .join(',');
    const shopifyDomain = 'motionboyz.myshopify.com';
    window.open(`https://${shopifyDomain}/cart/${lineItems}`, '_blank');
  };

  return (
    <>
      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black/70 z-[60] transition-opacity duration-300 ${isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
        onClick={closeCart}
      />

      {/* Drawer */}
      <div
        className={`fixed top-0 right-0 h-full w-[420px] max-w-full bg-[#0a0a0a] border-l border-[#00d4ff]/20 z-[70] flex flex-col transition-transform duration-500 ease-out ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-[#00d4ff]/10">
          <div className="flex items-center gap-3">
            <i className="ri-shopping-cart-line text-[#00d4ff] text-xl"></i>
            <h2 className="text-white font-bold text-lg tracking-widest uppercase">Your Cart</h2>
            {items.length > 0 && (
              <span className="w-5 h-5 flex items-center justify-center rounded-full bg-[#00d4ff] text-black text-xs font-bold">
                {items.reduce((s, i) => s + i.quantity, 0)}
              </span>
            )}
          </div>
          <button
            onClick={closeCart}
            className="w-9 h-9 flex items-center justify-center rounded-full border border-white/10 text-gray-400 hover:text-white hover:border-white/30 transition-all duration-200 cursor-pointer"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>

        {/* Items */}
        <div className="flex-1 overflow-y-auto px-6 py-4 space-y-4">
          {items.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full gap-4 text-center">
              <div className="w-16 h-16 flex items-center justify-center rounded-full border border-[#00d4ff]/20 text-[#00d4ff]/40">
                <i className="ri-shopping-cart-line text-3xl"></i>
              </div>
              <p className="text-gray-500 text-sm tracking-wider">Your cart is empty</p>
              <button
                onClick={closeCart}
                className="text-[#00d4ff] text-sm tracking-widest uppercase hover:underline cursor-pointer whitespace-nowrap"
              >
                Continue Shopping
              </button>
            </div>
          ) : (
            items.map((item) => (
              <div key={item.variantId} className="flex gap-4 bg-[#111] rounded-xl p-3 border border-white/5">
                <div className="w-20 h-20 flex-shrink-0 rounded-lg overflow-hidden bg-[#1a1a1a]">
                  <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-white text-sm font-semibold truncate">{item.name}</p>
                  <p className="text-[#00d4ff] text-sm font-medium mt-1">${item.price.toFixed(2)}</p>
                  <div className="flex items-center gap-2 mt-2">
                    <button
                      onClick={() => updateQuantity(item.variantId, item.quantity - 1)}
                      className="w-7 h-7 flex items-center justify-center rounded-full border border-white/10 text-white hover:border-[#00d4ff] hover:text-[#00d4ff] transition-all duration-200 cursor-pointer text-sm"
                    >
                      <i className="ri-subtract-line"></i>
                    </button>
                    <span className="text-white text-sm w-5 text-center">{item.quantity}</span>
                    <button
                      onClick={() => updateQuantity(item.variantId, item.quantity + 1)}
                      className="w-7 h-7 flex items-center justify-center rounded-full border border-white/10 text-white hover:border-[#00d4ff] hover:text-[#00d4ff] transition-all duration-200 cursor-pointer text-sm"
                    >
                      <i className="ri-add-line"></i>
                    </button>
                  </div>
                </div>
                <button
                  onClick={() => removeItem(item.variantId)}
                  className="self-start text-gray-600 hover:text-red-400 transition-colors duration-200 cursor-pointer mt-1"
                >
                  <i className="ri-delete-bin-line text-base"></i>
                </button>
              </div>
            ))
          )}
        </div>

        {/* Footer */}
        {items.length > 0 && (
          <div className="px-6 py-5 border-t border-[#00d4ff]/10 space-y-4">
            <div className="flex items-center justify-between">
              <span className="text-gray-400 text-sm tracking-wider uppercase">Subtotal</span>
              <span className="text-white text-xl font-bold">${totalPrice.toFixed(2)}</span>
            </div>
            <button
              onClick={handleCheckout}
              className="w-full py-4 bg-[#00d4ff] text-black font-bold text-sm tracking-widest uppercase rounded-full hover:bg-white transition-colors duration-300 cursor-pointer whitespace-nowrap"
              style={{ boxShadow: '0 0 30px rgba(0,212,255,0.4)' }}
            >
              Checkout
            </button>
            <button
              onClick={closeCart}
              className="w-full py-3 border border-white/10 text-gray-400 text-sm tracking-widest uppercase rounded-full hover:border-white/30 hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Continue Shopping
            </button>
          </div>
        )}
      </div>
    </>
  );
}
